import { Button, FileUploadButton } from "../Button";
import "./styles.css";

const ListItem = (props) => {
  return (
    <div
      className={`list-item ${props.className} ${props.active && "active"}`}
      onClick={props.onPress}
    >
      {props.image && (
        <div className="list-img-container">
          <img src={props.image} alt={props.name || props.title} />
        </div>
      )}
      {props.icon && (
        <div className={`icon-container mr-0-5 ${props.iconClassName}`}>
          <span className={process.env.REACT_APP_ICONS_TYPE}>{props.icon}</span>
        </div>
      )}
      <div className="content">
        <div style={{ display: "flex" }}>
          <span className="list-item-name text-bold">
            {props.name || props.title}
          </span>
          {props.required && (
            <span className="text-danger" style={{ paddingLeft: 4 }}>
              *
            </span>
          )}
        </div>
        {props.description && (
          <p className="text-description  mt-2">{props.description}</p>
        )}
      </div>
      {props.rightIcon && (
        <div className="list-right">
          <div className={`icon-container ${props.status && "success"}`}>
            <span className={process.env.REACT_APP_ICONS_TYPE}>
              {props.rightIcon}
            </span>
          </div>
        </div>
      )}
      {props.rightButtons && (
        <div className="list-right">
          {props.rightButtons.map((button) => {
            if (button.type === "upload") {
              return (
                <FileUploadButton
                  text={button.name}
                  onPress={button.onPress}
                  className="btn-transparent btn-bordered default"
                  handleFiles={button.onPress}
                />
              );
            } else if (button.type === "button") {
              return (
                <Button
                  text={button.name}
                  className="btn-transparent"
                  onPress={button.onPress}
                  icon={button.icon}
                />
              );
            }
          })}
        </div>
      )}
    </div>
  );
};

export default ListItem;
